import React from 'react';
import { Route } from 'react-router-dom';
import useCurrentUser from 'shared/../hooks/useCurrentUser';
import AccessDenied from 'shared/pages/AccessDenied';

const AccessRoute = ({ component: Component, requiredAccess, ...routeProps }) => {
  const { hasAccessTo } = useCurrentUser();

  const render = (props) => (
    requiredAccess.some(hasAccessTo)
      ? <Component {...props} />
      : <AccessDenied />
  );

  return (
    <Route
      exact
      {...routeProps}
      render={render}
    />
  );
};

export default AccessRoute;
